// Ported from seo-pages TikTok/utils/tiktok.ts; hostname must match exactly (no prefix spoofing).
const HOSTS = new Set(['tiktok.com', 'www.tiktok.com']);

export function getTikTokVideoId(url: unknown): string | null {
  if (typeof url !== 'string' || !url) return null;
  let parsed: URL;
  try {
    parsed = new URL(/^[a-z][a-z\d+.-]*:/i.test(url) ? url : `https://${url}`);
  } catch {
    return null;
  }
  if (parsed.protocol !== 'https:' || !HOSTS.has(parsed.hostname)) return null;
  return parsed.pathname.split(/\/video\//i)[1]?.split('/')[0] || null;
}
